<template>
  <div id="TranshipmentBarChart">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col class="d-flex align-center">
            <h6 style="word-break: break-word">{{ title }}</h6>
          </v-col>
          <v-col cols="6" class="d-flex justify-end">
            <v-radio-group row hide-details v-model="selectedType" @change="onTypeChange">
              <v-radio label="Nota" value="Nfe"></v-radio>
              <v-radio label="Entrega" value="Delivery"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <div>
          <div v-if="isLoading" class="d-flex justify-center align-center py-12">
            <v-progress-circular indeterminate color="primary" />
          </div>
          <ul class="list" v-else>
            <li v-for="(item, i) in transhipmentQuantityArray" :key="i" class="d-flex">
              <div class="status-label d-flex align-center" style="width: 75%">
                <div class="dot ml-1 mr-3" :style="{ background: item.color }" />
                {{ item.label }}
                <div>
                  <v-tooltip right>
                    <template #activator="{ attrs, on }">
                      <div class="align-self-start px-1">
                        <v-icon class="pa-0 ma-0" x-small v-bind="attrs" v-on="on"> mdi-information-outline </v-icon>
                      </div>
                    </template>
                    <div class="d-flex flex-column justify-center">
                      <div class="mx-auto">Status</div>
                      <ul>
                        <li v-for="status in item.iconStatuses" :key="status">{{ status }}</li>
                      </ul>
                    </div>
                  </v-tooltip>
                </div>
              </div>
              <div class="status-quantity d-flex align-center justify-end pr-2" style="width: 25%">
                {{ item.quantity }}
              </div>
            </li>
          </ul>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js';
import { mapActions } from 'vuex';
import { orderBy } from 'lodash';
export default {
  name: 'TranshipmentQuantityBarChart',
  props: {
    transhipmentId: {
      default: null,
      type: String
    },

    date: {
      default: null,
      type: Object
    }
  },
  data: () => ({
    isLoading: false,
    chartOptions: {},
    chartLabels: [],
    chartData: [],
    charts: null,
    transhipmentQuantity: null,
    types: [
      { text: 'Nota', value: 'Nfe' },
      { text: 'Entrega', value: 'Delivery' }
    ],
    selectedType: 'Nfe'
  }),

  computed: {
    transhipmentData() {
      const barColors = [
        { color: 'rgba(54, 162, 235, 0.2)', borderColor: 'rgba(54, 162, 235, 1)' },
        { color: 'rgba(75, 192, 192, 0.2)', borderColor: 'rgba(75, 192, 192, 1)' },
        { color: 'rgba(255, 206, 86, 0.2)', borderColor: 'rgba(255, 206, 86, 1)' },
        { color: 'rgba(255, 99, 132, 0.2)', borderColor: 'rgba(255, 99, 132, 1)' },
        { color: 'rgba(255, 159, 64, 0.2)', borderColor: 'rgba(255, 159, 64, 1)' },
        { color: 'rgba(153, 102, 255, 0.2)', borderColor: 'rgba(153, 102, 255, 1)' },
        { color: 'rgba(26, 255, 26, 0.2) ', borderColor: 'rgba(0, 179, 0, 1)' },
        { color: 'rgba(255, 0, 102, 0.2)', borderColor: 'rgba(179, 0, 71, 1)' }
      ];
      const labels = [
        'Transferência',
        'Aceito pelo transbordo',
        'Em entrega',
        'Quarentena de transferência',
        'Quarentena de entrega',
        'Em devolução',
        'Finalizado',
        'Devolvido'
      ];
      let datasets = [];

      if (this.transhipmentQuantity !== null) {
        Object.keys(this.transhipmentQuantity).map((key, i) => {
          let newDataset = {
            label: labels[i],
            data: [this.transhipmentQuantity[key]],
            backgroundColor: [barColors[i].color],
            borderColor: [barColors[i].borderColor],
            borderWidth: 1
          };
          datasets = [...datasets, newDataset];
        });
        return datasets;
      }

      return [];
    },

    title() {
      return this.selectedType === 'Nfe' ? 'Quantidade de notas por status' : 'Quantidade de entregas por status';
    },

    transhipmentQuantityArray() {
      const statuses = {
        quantityOnTransfer: { label: 'Em transferência', color: '#227BD4', statuses: ['Em transferência'] },
        quantityAcceptedTransshipment: {
          label: 'Aceito pelo transbordo',
          color: '#154d84',
          statuses: ['Aceito pelo transbordo']
        },
        quantityBeingDelivered: {
          label: 'Em entrega',
          color: '#7bb3ea',
          statuses: ['Tentar entregar novamente', ' Alocado para entregador']
        },
        quantityQuarantine: {
          label: 'Quarentena de transferência',
          color: '#ffcc66',
          statuses: ['Quarentena de transferência']
        },
        quantityDeliveryQuarantine: {
          label: 'Quarentena de entrega',
          color: '#ff6666',
          statuses: ['Quarentena de entrega']
        },
        quantityToBeReturned: { label: 'Em devolução', color: '#ff8c1a  ', statuses: ['A devolver'] },
        quantityFinalized: {
          label: 'Finalizado',
          color: '#36e23f',
          statuses: ['Entregue com sucesso', 'Entregue com pendência']
        },
        quantityReturns: {
          label: 'Devolvido',
          color: '#98e698',
          statuses: [
            'Devolvido com sucesso',
            'Devolvido com pendência',
            'Devolvido para reentrega',
            'Devolvido pelo transbordo'
          ]
        }
      };

      if (this.transhipmentQuantity) {
        let array = Object.entries(this.transhipmentQuantity).reduce((acc, [key, value]) => {
          const { label, color, statuses: iconStatuses } = statuses[key];
          return [...acc, { label, color, iconStatuses, quantity: value }];
        }, []);
        return orderBy(array, ['quantity'], ['desc']);
      }
      return null;
    }
  },

  watch: {
    date: {
      async handler() {
        await this.fetchTranshipmentQuantityData({
          startDate: this.date.startDate,
          endDate: this.date.endDate,
          transhipmentId: this.transhipmentId,
          type: this.selectedType
        });
      }
    }
  },

  created() {
    Chart.register(...registerables);
  },

  async mounted() {
    await this.fetchTranshipmentQuantityData();
  },

  methods: {
    ...mapActions('TranshipmentStore', [
      'getTranshipmentsDashboardQuantityDataByTranshipmentId',
      'getTranshipmentsDashboardQuantityData'
    ]),
    async fetchTranshipmentQuantityData(
      params = { startDate: '', endDate: '', transhipmentId: this.transhipmentId, type: this.selectedType }
    ) {
      try {
        this.isLoading = true;

        if (params.transhipmentId !== null) {
          const data = await this.getTranshipmentsDashboardQuantityDataByTranshipmentId(params);
          this.transhipmentQuantity = data;
        } else {
          const data = await this.getTranshipmentsDashboardQuantityData(params);
          this.transhipmentQuantity = data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    async onTypeChange() {
      const startDate = this.date !== null ? this.date.startDate : '';
      const endDate = this.date !== null ? this.date.endDate : '';
      await this.fetchTranshipmentQuantityData({
        startDate,
        endDate,
        transhipmentId: this.transhipmentId,
        type: this.selectedType
      });
    },

    renderChart() {
      const data = {
        labels: [''],
        datasets: this.transhipmentData
      };
      const options = this.chartOptions;
      const config = {
        type: 'bar',
        data: data,
        options: options
      };
      this.charts = new Chart(document.getElementById('transhipmentQuantityById'), config);
    },

    fillChartData() {
      this.chartOptions = {
        scales: {
          y: {
            suggestedMin: 0,
            suggestedMax: 100,
            ticks: {
              stepSize: 20
            }
          },
          x: {
            ticks: {
              font: {
                size: 13
              }
            }
          }
        },
        plugins: {
          tooltip: {
            intersect: false,
            bodyFont: { weight: 'bold' },
            yAlign: 'centered'
          },
          legend: {
            position: 'bottom'
          }
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  list-style: none;
  margin: 0;
  padding: 0;
  height: 250px;
  overflow-y: auto;

  & li {
    background-color: #e2e2e236;
    padding: 14px 12px;
    margin: 5px;
    border-radius: 2px;

    & .status-label,
    .status-quantity {
      color: rgb(60, 60, 60);
      font-weight: 400;
      font-size: 0.95rem;
    }

    & .dot {
      min-height: 10px;
      min-width: 10px;
      background-color: #bbb;
      border-radius: 50%;
    }
  }

  & li:hover {
    background-color: #fff;
  }
}
/* ===== Scrollbar CSS ===== */
/* Firefox */
.list {
  scrollbar-width: thin;
  scrollbar-color: #c7c7c7 #ffffff;
}

/* Chrome, Edge, and Safari */
.list::-webkit-scrollbar {
  width: 6px;
}

.list::-webkit-scrollbar-track {
  background: #ffffff;
}

.list::-webkit-scrollbar-thumb {
  background-color: #c7c7c7;
  border-radius: 10px;
}

.loading-screen {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: white;

  border-radius: 5px;
}
</style>
